import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { DocumentTemplate } from "../models/document-template.model";
import { Bookmark } from "../models/bookmakmodel";


@Injectable()
export class BookmarkTemplateService extends EndpointFactory  {


    private _baseURl = "";

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getBookmarkTemplates(): Observable<any> {
        return this.http
            .get(this._baseURl + `api/documentTemplate/get-bookmark-templates`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    getBookmarksById(documentTemplateId: string): Observable<any> {
        return this.http
            .get(this._baseURl + `api/documentTemplate/get-bookmarks/${documentTemplateId}`, this.getRequestHeaders())
            .catch(err => {return this.handleError(err,null)})
    }

    getGlobalBookmarks(): Observable<any> {
        return this.http
            .get(this._baseURl + `api/documentTemplate/get-global-bookmarks`, this.getRequestHeaders())
            .catch(err => {return this.handleError(err, null)})
    }

    createDocumentTemplate(template: DocumentTemplate): Observable<DocumentTemplate> {
        return this.http
            .post(this._baseURl + `api/documentTemplate/create-template`, template, this.getRequestHeaders())
            .catch(err => { return this.handleError(err, null) })
    }

    updateDocumentTemplate(template: DocumentTemplate): Observable<DocumentTemplate> {
        return this.http
            .put(this._baseURl + `api/documentTemplate/update-document-template`, template, this.getRequestHeaders())
            .catch(err => {return this.handleError(err,null)})
    }

    updateBookmark(bookmark: Bookmark): Observable<Bookmark> {
        return this.http
            .put(this._baseURl + `api/documentTemplate/update-bookmark`, bookmark, this.getRequestHeaders())
            .catch(err => { return this.handleError(err, null) })
    }

    getTemplateById(documentTemplateId): Observable<any> {
        return this.http
            .get(this._baseURl + `api/documentTemplate/get-template-by-id/${documentTemplateId}`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    createBookmark(bookmark: Bookmark, documentTemplateId: number): Observable<any> {
        return this.http
            .post(this._baseURl + `api/documentTemplate/create-bookmark/${documentTemplateId}`, bookmark, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }

    createGlobalookmark(bookmark: Bookmark): Observable<any> {
        return this.http
            .post(this._baseURl + `api/documentTemplate/create-global-bookmark`, bookmark, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }


    saveFormData(documentId: string, formData: any) {
        return this.http
            .post(this._baseURl + `api/documentTemplateFormValue/save-form-data/${documentId}`, formData, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }


    updateAllBookmark(bookmarks) {
        return this.http
            .post(this._baseURl + `api/documentTemplate/update-all-bookmark`, bookmarks, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }

    deleteBookmark(bookmarks: Bookmark): Observable<any> {
        return this.http
            .post(this._baseURl + `api/documentTemplate/delete-bookmark`, bookmarks, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }
}

    


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/bookmark-template.service.ts